import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DoneIcon from '@mui/icons-material/Done';
import { Link } from 'react-router-dom';

const Listing = () => {
    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Listing</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-9'>
                        <div className='business-listing'>
                            <div className='imgbox'>
                                <img src='images/general-store-img.jpg' alt='General Store' />
                                <div className='businesstype'>Wholesale</div>
                            </div>
                            <div className='detail-box'>
                                <div className='title-box'><Link to="/Details"><VerifiedIcon /> Prajapati General Store</Link></div>
                                <div className='location-box'><FmdGoodOutlinedIcon/> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                                <div className='service-box'>
                                    <div className='services'><DoneIcon/> Medicine</div>
                                    <div className='services'><DoneIcon/> Pooj Samagri</div>
                                    <div className='services'><DoneIcon/> Cloths</div>
                                    <div className='services'><DoneIcon/> Ladies Accessories</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> All General Products</div>
                                </div>
                                <div className='btn-box'>
                                    <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                                </div>
                            </div>
                            <div className='clr'></div>
                        </div>
                        <div className='business-listing'>
                            <div className='imgbox'>
                                <img src='images/general-store-img.jpg' alt='General Store' />
                                <div className='businesstype'>Wholesale</div>
                            </div>
                            <div className='detail-box'>
                                <div className='title-box'><Link to="/"><VerifiedIcon /> Prajapati General Store</Link></div>
                                <div className='location-box'><FmdGoodOutlinedIcon/> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                                <div className='service-box'>
                                    <div className='services'><DoneIcon/> Medicine</div>
                                    <div className='services'><DoneIcon/> Pooj Samagri</div>
                                    <div className='services'><DoneIcon/> Cloths</div>
                                    <div className='services'><DoneIcon/> Ladies Accessories</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> All General Products</div>
                                </div>
                                <div className='btn-box'>
                                    <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                                </div>
                            </div>
                            <div className='clr'></div>
                        </div>
                        <div className='business-listing'>
                            <div className='imgbox'>
                                <img src='images/general-store-img.jpg' alt='General Store' />
                                <div className='businesstype'>Wholesale</div>
                            </div>
                            <div className='detail-box'>
                                <div className='title-box'><Link to="/"><VerifiedIcon /> Prajapati General Store</Link></div>
                                <div className='location-box'><FmdGoodOutlinedIcon/> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                                <div className='service-box'>
                                    <div className='services'><DoneIcon/> Medicine</div>
                                    <div className='services'><DoneIcon/> Pooj Samagri</div>
                                    <div className='services'><DoneIcon/> Cloths</div>
                                    <div className='services'><DoneIcon/> Ladies Accessories</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> All General Products</div>
                                </div>
                                <div className='btn-box'>
                                    <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                                </div>
                            </div>
                            <div className='clr'></div>
                        </div>
                        <div className='business-listing'>
                            <div className='imgbox'>
                                <img src='images/general-store-img.jpg' alt='General Store' />
                                <div className='businesstype'>Wholesale</div>
                            </div>
                            <div className='detail-box'>
                                <div className='title-box'><Link to="/"><VerifiedIcon /> Prajapati General Store</Link></div>
                                <div className='location-box'><FmdGoodOutlinedIcon/> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                                <div className='service-box'>
                                    <div className='services'><DoneIcon/> Medicine</div>
                                    <div className='services'><DoneIcon/> Pooj Samagri</div>
                                    <div className='services'><DoneIcon/> Cloths</div>
                                    <div className='services'><DoneIcon/> Ladies Accessories</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> All General Products</div>
                                </div>
                                <div className='btn-box'>
                                    <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                                </div>
                            </div>
                            <div className='clr'></div>
                        </div>
                        <div className='business-listing'>
                            <div className='imgbox'>
                                <img src='images/general-store-img.jpg' alt='General Store' />
                                <div className='businesstype'>Wholesale</div>
                            </div>
                            <div className='detail-box'>
                                <div className='title-box'><Link to="/"><VerifiedIcon /> Prajapati General Store</Link></div>
                                <div className='location-box'><FmdGoodOutlinedIcon/> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                                <div className='service-box'>
                                    <div className='services'><DoneIcon/> Medicine</div>
                                    <div className='services'><DoneIcon/> Pooj Samagri</div>
                                    <div className='services'><DoneIcon/> Cloths</div>
                                    <div className='services'><DoneIcon/> Ladies Accessories</div>
                                    <div className='services'><DoneIcon/> Dry Fruits</div>
                                    <div className='services'><DoneIcon/> Potato</div>
                                    <div className='services'><DoneIcon/> Onion</div>
                                    <div className='services'><DoneIcon/> Garlic</div>
                                    <div className='services'><DoneIcon/> All General Products</div>
                                </div>
                                <div className='btn-box'>
                                    <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                    <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                                </div>
                            </div>
                            <div className='clr'></div>
                        </div>
                    </div>
                    <div className='col-md-3'></div>
                </div>
            </div>
        </div>
    )
}

export default Listing
